import fetch from "auth/FetchInterceptor";

const cortesiaService = {};

// ----- Admin (dashboard / detalhe do profissional) -----

/** Planos de cortesia disponíveis pra escolher na ativação (ex: fundador, migração). */
cortesiaService.getPlanosCortesia = async () =>
	fetch({ url: "/v1/rest/cortesia/planos", method: "get" });

/** Histórico de contratações de um profissional (aba "contratações"). */
cortesiaService.getHistorico = async (idUsuario) =>
	fetch({ url: `/v1/rest/cortesia/historico/${idUsuario}`, method: "get" });

/** Worklist: todas as cortesias ativas (com retorno deduzido). */
cortesiaService.getCortesiasAtivas = async () =>
	fetch({ url: "/v1/rest/cortesia/ativas", method: "get" });

/** Ativa uma cortesia começando agora. dataFim = "YYYY-MM-DD" ou null (permanente). */
cortesiaService.ativar = async ({ idUsuario, idPlanoCortesia, dataFim }) =>
	fetch({
		url: "/v1/rest/cortesia/ativar",
		method: "post",
		data: {
			id_usuario: idUsuario,
			id_plano_cortesia: idPlanoCortesia,
			data_fim: dataFim,
		},
	});

/** Define/edita o término de uma cortesia ativa. dataFim = "YYYY-MM-DD" ou null. */
cortesiaService.definirTermino = async ({ idUsuario, dataFim }) =>
	fetch({
		url: "/v1/rest/cortesia/definir-termino",
		method: "post",
		data: { id_usuario: idUsuario, data_fim: dataFim },
	});

// ----- Profissional logado (modal de fim de período) -----

/**
 * Decide se o modal de fim de cortesia deve aparecer. Silencioso em erro
 * (no-notification): é um check de background, não deve incomodar o usuário.
 */
cortesiaService.getAvisoFimCortesia = async () =>
	fetch({
		url: "/v1/rpc/aviso-fim-cortesia",
		method: "get",
		headers: { "no-notification": true },
	});

/** Registra a prova: 'ok' (fechou) ou 'clicou_contratar'. */
cortesiaService.reconhecerAviso = async (acao) =>
	fetch({
		url: "/v1/rpc/aviso-fim-cortesia/reconhecer",
		method: "post",
		data: { acao },
	});

export default cortesiaService;
